var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('person-link');
import { breakpoints, theme } from '@shapeable/theme';
import { PersonCell } from './person-cell';
import { EntityLink } from './entity-link';
import { Icon } from '../elements/icon';
import { Icons } from '../icons';
export var PersonLinkDefaultProps = {
  showArrow: false
}; // -------- Child Component Props -------->
// -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: ", ";\n    padding: ", ";\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-start;\n\n    &:hover {\n      filter: brightness(104%);\n    }\n  "], ["\n    background: ", ";\n    padding: ", ";\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-start;\n\n    &:hover {\n      filter: brightness(104%);\n    }\n  "])), theme.BG('formPanel'), theme.UNIT(3))
});
var CellStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var IconStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-top: ", ";\n    margin-right: ", ";\n  "], ["\n    margin-top: ", ";\n    margin-right: ", ";\n  "])), theme.UNIT(1), theme.UNIT(1))
}); // -------- Components -------->

var My = {
  Container: styled(EntityLink)(templateObject_4 || (templateObject_4 = __makeTemplateObject([""], [""]))),
  Cell: styled(PersonCell)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), CellStyles),
  Icon: styled(Icon)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
My.Container = styled(EntityLink)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), ContainerStyles);
export var PersonLink = function PersonLink(props) {
  var className = props.className,
      entity = props.entity,
      showArrow = props.showArrow;
  return React.createElement(My.Container, {
    entity: entity,
    className: cls.name(className)
  }, React.createElement(My.Cell, {
    entity: entity
  }), showArrow && React.createElement(My.Icon, {
    size: 16
  }, React.createElement(Icons.ChevronRight, null)));
};
PersonLink.defaultProps = PersonLinkDefaultProps;
PersonLink.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;